import { RadioButtonV2, RadioButtonV2Props } from './RadioButton';

type RadioButtonV2Options = RadioButtonV2Props;

export type RadioGroupV2Props = Omit<React.HTMLAttributes<HTMLDivElement>, 'onChange'> & {
	name: string;
	value: string;
	options: RadioButtonV2Options[];
	groupLabel: string;
	dataTestId?: string;
	onValueChange: (value: string) => void;
};

export const RadioGroupV2 = ({
	name,
	value,
	options,
	groupLabel,
	dataTestId = '',
	onValueChange,
	...rest
}: RadioGroupV2Props) => {
	return (
		<fieldset className='block'>
			<legend className='block text-primaryTextDark'>{groupLabel}</legend>
			<div role='radiogroup' data-test-id={dataTestId} className='pt-4' {...rest}>
				{options.map((opt: RadioButtonV2Options, i: number) => (
					<RadioButtonV2
						key={i}
						label={opt.label}
						name={name}
						value={opt.value}
						checked={opt.value === value}
						onChange={(e) => {
							if (e.target.checked) onValueChange(opt.value);
						}}
					/>
				))}
			</div>
		</fieldset>
	);
};
